<template>
    <section>
        <b-tabs type="is-toggle" position="is-centered" v-model="currentTab" :multiline="true">
            <b-tab-item v-for="item in items" v-bind:key="item.content" :value="item.content" :label="item.tab"
                :disabled="item.disabled" />
        </b-tabs>
        <!-- COMPONENTE AQUI -->
        <keep-alive>
            <component v-bind:is="currentTabComponent" :person-id="personId" :photo-url="photoUrl"
                :cargo-principal="cargoPrincipal" :hide-update="true" :can-create-document="canCreateDocument" :can_create_work_experience='can_create_work_experience'/>
        </keep-alive>

        <!-- FIN COMPONENTE -->
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import MyAcademicProfileUSACH from './my_academic_profile_usach_tab.vue'
import MyAcademicProfileExternal from './my_academic_profile_external.vue';
export default {
    components: {
        MyAcademicProfileUSACH, MyAcademicProfileExternal,
    },
    props: [
        'personId', 'photoUrl', 'cargoPrincipal', 'canCreateDocument', 'can_create_work_experience'
    ],
    data() {
        return {
            isLoading: false,
            currentTab: 'MyAcademicProfileUSACH',
            items: [
                { tab: 'Mi Perfil Docente USACH', content: 'MyAcademicProfileUSACH', icon: "briefcase", disabled: false },
                { tab: 'Mi Perfil Docente Externa', content: 'MyAcademicProfileExternal', icon: "briefcase", disabled: false },
            ],
        }
    },
    methods: {
        changeTab: function (value) {
            this.currentTab = value
        },
    },
    computed: {
        currentTabComponent: function () {
            return this.currentTab
        }
    }
}
</script>